import React from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DatePicker } from 'antd';
import trTR from 'antd/es/date-picker/locale/tr_TR';
import enGB from 'antd/es/date-picker/locale/en_GB';
import jaJP from 'antd/es/date-picker/locale/ja_JP';
import { Controller } from 'react-hook-form';
import Span from 'src/components/ui/Span';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormInstructions } from 'src/helpers/multilingualHelper';

dayjs.extend(customParseFormat);

const DateClientForm = ({ elementId, label, name, required, placeholder, control, errors, config, onChange: onChangeCustom, value }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const resolvedLanguage = i18n.resolvedLanguage || i18n.language;
    const datePickerLocale = resolvedLanguage?.startsWith('tr') ? trTR : resolvedLanguage?.startsWith('ja') ? jaJP : enGB;

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);

    const parseInputToDate = (inputValue) => {
        const formattedValue = inputValue?.trim();
        if (!formattedValue) {
            return null;
        }
        const formats = ['DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY', 'DDMMYYYY'];
        for (const format of formats) {
            const parsedDate = dayjs(formattedValue, format, true);
            if (parsedDate.isValid()) {
                return parsedDate;
            }
        }
        return null;
    };

    const handleDateChange = (date, field) => {
        field.onChange(dayjs(date).format("YYYY-MM-DD"));
        if (onChangeCustom) {
            onChangeCustom(elementId, null, dayjs(date).format("YYYY-MM-DD"));
        }
    };
    return (
        <div className="relative inline-block w-full">
            <label htmlFor={elementId} className={`block ${config.hasInstructions ? '' : 'mb-2'} text-sm text-gray-700`}>
                {displayLabel}{required && '*'}
            </label>
            {
                config.hasInstructions && <label className="mb-2 text-xs text-gray-300">
                    {displayInstructions}
                </label>
            }

            <Controller
                name={elementId}
                control={control}
                rules={{
                    required: {
                        value: required,
                        message: t('form.thisFieldRequired')
                    }
                }}
                render={({ field }) => {
                    if (!field.value && value) {
                        field.onChange(value);
                    }
                    const dateValue = field.value ? dayjs(field.value) : null;
                    return (<div className="relative">
                        <DatePicker
                            onChange={(date, dateString) => {
                                handleDateChange(dayjs(date), field);
                            }}
                            onKeyDown={(event) => {
                                if (event.key !== 'Enter') {
                                    return;
                                }
                                event.preventDefault();
                                event.stopPropagation();
                                const parsedDate = parseInputToDate(event.target?.value);
                                if (parsedDate) {
                                    handleDateChange(dayjs(parsedDate), field);
                                }
                            }}
                            required={required}
                            value={dateValue}
                            locale={datePickerLocale}
                            format="DD-MM-YYYY"
                            onBlur={(event) => {
                                if (!event?.target?.value) {
                                    return;
                                }
                                const parsedDate = parseInputToDate(event.target.value);
                                if (parsedDate) {
                                    handleDateChange(parsedDate, field);
                                }
                            }}
                            placeholder={placeholder || 'DD-MM-YYYY'}
                            allowClear={false}
                            className={`customDatePicker input w-full placeholder-gray-300 p-2 border border-gray-300 rounded-2xl h-13 focus:outline-none focus:border-SorrellBrown5000 ${errors[elementId] ? 'border-red-500' : ''}`}
                        />
                    </div>)
                }}
            />
            {errors[elementId] && <Span className="text-FailRed400 text-xxs">{errors[elementId].message}</Span>}
        </div>
    );
};

export default DateClientForm;
